import { render, staticRenderFns } from "./shareOrder.vue?vue&type=template&id=dc5e4706&scoped=true"
import script from "./shareOrder.vue?vue&type=script&lang=js"
export * from "./shareOrder.vue?vue&type=script&lang=js"
import style0 from "./shareOrder.vue?vue&type=style&index=0&id=dc5e4706&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5e4706",
  null
  
)

export default component.exports